// import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
// import { authRoles } from "./auth/authRoles";

// import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

import sessionRoutes from "./views/sessions/session-routes";
import { AuthProvider } from "./contexts/JWTAuthContext";
import DailyTimeRecordRoutes from "./views/Dailytimerecord/calendar-routes";
import TimeKeepingRoutes from "./views/Timekeeping/timekeeping-routes";
import TaskRoutes from "./views/Task/task-routes";
import verifyRoutes from "./views/verify/verify-routes";
import maintenanceRoutes from "./views/Maintenance/Maintenance-routes";
// import PayslipRoutes from "./views/payslip/payslip-routes";

// const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));

const routes = [
  {
    path: "/",
    element: <Navigate to="Dtr" />
  },
  {
    element: (
      <AuthProvider>
        <AuthGuard>
          <MatxLayout />
        </AuthGuard>
      </AuthProvider>
    ),
    children: [
      // dashboard route
      ...TimeKeepingRoutes,
      ...DailyTimeRecordRoutes,
      ...TaskRoutes,
      ...verifyRoutes,
      ...maintenanceRoutes
      // ...PayslipRoutes,
      // {
      //   path: "Dtr",
      //   element: <Analytics />,
      //   auth: authRoles.user,
      // },
    ]
  },

  // session pages route
  ...sessionRoutes
];

export default routes;
